/* global module, require */
const createDocument = require('../createDocument'),
	makeToughenedGlass = require('../func/makeGlass'),
	makeLaminatedGlass = require('../func/makeLaminatedGlass');

const glassCT = 'Clear Toughened',
	glassCTL = 'Clear Toughened Laminated';

function getGlassThickness(type, array) {
	return {
		name: 'Glass Thickness',
		options: array[type],
		transform: parseFloat,
	};
}

function getGlassType(info) {
	return {
		name: 'Glass Type',
		options: {
			Toughened: glassCT,
			Laminate: glassCTL,
		},
		info,
	};
}

const makeGlassFn = {
	[glassCT]: makeToughenedGlass,
	[glassCTL]: makeLaminatedGlass,
};

function makeGlass(type, options) {
	return makeGlassFn[type](options);
}

module.exports = {
	makeGlass,
	getGlassThickness,
	getGlassType,
	glassCT,
	glassCTL,
	glassDefault: glassCT,
};
